import React, { useState, useEffect, useRef } from "react";
import "../../../../../../../css/workspace.css";
import $ from "jquery";
import * as types from "../../../../../../../redux/constants/collectionConstants";
import {
  queryDocumentV2,
  uploadDocumentV2,
  uploadDocumentV2AzureService,
  uploadUrlV2,
  getTrainedDataV2,
  deleteTrainedDataV2,
  sendInputAnswerV2,
  getDocUploadStatusV2,
  deleteDocumentV2,
  getWalkthroughs,
  updateWalkthroughs,
  uploadInstructionV2,
  getChatHistoryV2,
  getSqlQueryV2,
  getAudio,
  thumbsAction,
  uploadUrl,
  uploadTextV2
} from "../../../../../../../redux/actions/collectionsV2";
import { connect, useSelector, useDispatch} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Button,
  Input,
  Radio,
} from "antd";
import { notify } from "../../../../../../../components/Snack";

const AddURL = () => {

    const [valueScrape, setValueScrape] = useState(1);
    const [uploadURLText, setUploadURLText] = useState("");
    const [resourceName, setResourceName] = useState("");
    const [loading, setLoading] = useState(false);
    const [docsList, setDocsList] = useState([]);
    
    const [docListTemp, setDocListTemp] = useState([]);
    const [docSelected, setDocSelected] = useState("");

    const dispatch = useDispatch();
    const queryParams = useLocation().search;

    const collectionName =  new URLSearchParams(queryParams).get("name");

    const documentsList = useSelector(
      (state) => state.collectionReducer.collectionDocs
    );

    useEffect(() => {
      setDocsList(documentsList);
    }, [documentsList]);

    const groupPlan = useSelector((state) => state.userReducer.groupPlan);
    let planType;
    if (groupPlan?.planId == 4) {
        planType = "team";
    } else if (groupPlan?.planId == 5) {
        planType = "business";
    } else {
        planType = "pro";
    }

    const uniqueDocuments = (arr) => {
      const seen = new Map();
  
      arr.forEach((doc) => {
        const { document_name, status } = doc;
        // If the document name is not in the map, add it
        if (!seen.has(document_name)) {
          seen.set(document_name, doc);
        } else {
          // If it exists, check the status
          if (status === "success") {
            // If the new doc has status success, replace the existing one
            seen.set(document_name, doc);
          }
        }
      });
      // Convert the map back to an array
      return Array.from(seen.values());
    };


    useEffect(() => {
      if (docsList?.length > 0) {
        
        const result = uniqueDocuments(docsList);
        dispatch({
          type: types.UPDATE_COLLECTION_DOCS_LIST,
          collectionDocs: result,
        });
      }
    }, [docsList]);
    
    const onChangeScrape = (e) => {
        setValueScrape(e.target.value);
      };

    const addURL = async () => {
    if (
        !(
        uploadURLText.startsWith("http://") ||
        uploadURLText.startsWith("https://")
        )
    ) {
        dispatch(notify("error", "Please enter a valid URL"));
        return;
    }
    if (resourceName?.length < 1) {
        dispatch(notify("error", "Please enter a valid Resource name"));
        return;
    }
    if(resourceName.length >= 64){
      dispatch(notify("error", "Resource name must be less than 64 characters"));
      return;
    }

    //history.push(`/collections?name=${collectionName}&c=${docCount + 1}&doc=${resourceName}`);

    let createResponse;
    
                      setDocsList((prevArray) => [
                          ...prevArray,
                          {
                            document_name: resourceName,
                            status: "in-progress",
                            text_data: null,
                          },
                        ]);    
                        setLoading(true);
    createResponse = await uploadUrlV2(
        collectionName,
        uploadURLText,
        resourceName,
        planType,
        valueScrape
    );
    
    setLoading(false);

    if (createResponse?.data?.status == "OK") {
      valueScrape == 2 ? dispatch(
        notify("success",
          "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
        )
      ) :
      dispatch(notify("success", "The URL has been vectorised and stored."));
        
        setDocsList((prevArray) => [
          ...prevArray,
          {
            document_name: resourceName,
            status: "success",
            text_data: null,
          },
        ]);

        setDocListTemp(docsList);
        
        setUploadURLText("");
        setResourceName("");
    } else if(createResponse?.data?.status == "EXCEPTION"){
        dispatch(
        notify("error", createResponse?.data?.message)
        );
    } else{
      dispatch(
        notify("error", "Something went wrong, please refresh the page")
        );
    }
    };

    return(
        <>
        <div className="add-url-block" style={{marginTop: '20px'}}>
        <div className="radio-options" style={{marginBottom: '10px'}}>
                      <Radio.Group
                        onChange={onChangeScrape}
                        defaultValue={valueScrape}
                      >
                        <Radio value={1}>Scrape URL Only</Radio>
                        <Radio value={2}>Scrape Entire Website</Radio>
                      </Radio.Group>
        </div>
        <div className="img-selector">

        <div className="up-flex-items doc-url">
            
            <div style={{marginBottom: '10px'}} className="input-clear">
            <h6>Resource name</h6>
              <Input
                type="text"
                size="small"
                value={resourceName}
                placeholder="Enter Resource name"
                onChange={(e) =>
                  setResourceName(e.target.value)
                }
              />
            </div>
          </div>
          
          <div className="up-flex-items">
            <Input
              type="text"
              size="small"
              value={uploadURLText}
              placeholder="Enter URL"
              onChange={(e) => setUploadURLText(e.target.value)}
            />
          </div>

          <div className="btn-flex-1 text-center" style={{marginTop: '10px'}}>
            {loading ? 
            (<Button type="primary" size="small">
              Processing...
            </Button>
            )
            :
            (<Button type="primary" size="small" onClick={(e) => addURL()}>
              Submit
            </Button>
            )
            }
          </div>
        </div>
      </div>
      </>
    )
}
export default AddURL;